import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const DurationPicker = ({
  title,
  disabled,
  schema,
  onChange,
}: FieldExtensionComponentProps<number>) => {
  const configApi = useApi(configApiRef);
  const [selected, setSelected] = useState(schema.default || 0);

  const setValue = useCallback((candidate?: string | number) => {
    let value = Number(candidate);
    if (isNaN(value)) value = 0;
    setSelected(value);
    onChange(value);
  }, [onChange])
  
  const items = useMemo(() => {
    const rotationRoles = configApi.getOptionalString('app.clientManager.secretDurations');
    const items = rotationRoles?.split(/[,;]/).map(r => Number(r.trim()));
    return items ?? [];
  }, [configApi]);

  useEffect(() => {
    const storedValue = sessionStorage.getItem('durationPickerValue');
    if (storedValue) setValue(storedValue);
  }, []);

  useEffect(() => {
    sessionStorage.setItem('durationPickerValue', selected.toString());
  }, [selected]);

  return (
    <FormControl fullWidth>
      <InputLabel>{schema.description}</InputLabel>
      <Select
        value={selected}
        label={title}
        disabled={disabled}
        onChange={(e) => setValue(e.target?.value as number)}
      >
        <MenuItem value={0}>Indeterminado</MenuItem>
        {items?.map(item =>
          <MenuItem value={item}>{`${item} Dias`}</MenuItem>
        )}        
      </Select>
    </FormControl>
  );
};
